import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/auth.php';

export default function VerificarEmail() {
  const [params]  = useSearchParams();
  const [estado,  setEstado]  = useState('cargando'); // cargando | ok | error
  const [mensaje, setMensaje] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setEstado('error'); setMensaje('Token no válido'); return; }

    fetch(`${API}?action=verificar&token=${token}`)
      .then(r => r.json())
      .then(j => {
        if (j.success) setEstado('ok');
        else { setEstado('error'); setMensaje(j.message); }
      })
      .catch(() => { setEstado('error'); setMensaje('Error de conexión'); });
  }, []);

  return (
    <div style={{minHeight:'100vh',background:'#111614',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'DM Sans,sans-serif',padding:'2rem'}}>
      <div style={{background:'#fff',borderRadius:'20px',padding:'3rem 2.5rem',maxWidth:'440px',width:'100%',textAlign:'center',boxShadow:'0 24px 80px rgba(0,0,0,.3)'}}>

        {estado === 'cargando' && (
          <>
            <div style={{width:60,height:60,borderRadius:'50%',border:'3px solid #d4f4e8',borderTopColor:'#4db88a',animation:'spin .7s linear infinite',margin:'0 auto 1.5rem'}}/>
            <p style={{color:'#5a6a63'}}>Verificando tu email…</p>
            <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
          </>
        )}

        {estado === 'ok' && (
          <>
            <div style={{width:72,height:72,background:'#d4f4e8',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 1.5rem'}}>
              <svg viewBox="0 0 24 24" fill="none" width="36" height="36"><path d="M8 12l3 3 5-5" stroke="#4db88a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </div>
            <h2 style={{fontFamily:'Cormorant Garamond,serif',fontSize:'1.8rem',color:'#111614',marginBottom:'.8rem'}}>¡Email verificado!</h2>
            <p style={{color:'#5a6a63',marginBottom:'2rem',lineHeight:1.7}}>Tu cuenta está activa. Ya puedes acceder a todos tus beneficios.</p>
            <Link to="/mi-cuenta" style={{display:'inline-block',background:'#111614',color:'#fff',fontWeight:700,padding:'.85rem 2rem',borderRadius:'100px',textDecoration:'none'}}>
              Ir a mi cuenta →
            </Link>
          </>
        )}

        {estado === 'error' && (
          <>
            <div style={{width:72,height:72,background:'#fee2e2',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 1.5rem'}}>
              <svg viewBox="0 0 24 24" fill="none" width="36" height="36"><line x1="18" y1="6" x2="6" y2="18" stroke="#e53e3e" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="#e53e3e" strokeWidth="2.5" strokeLinecap="round"/></svg>
            </div>
            <h2 style={{fontFamily:'Cormorant Garamond,serif',fontSize:'1.8rem',color:'#111614',marginBottom:'.8rem'}}>Enlace inválido</h2>
            <p style={{color:'#5a6a63',marginBottom:'2rem'}}>{mensaje || 'El enlace expiró o ya fue usado.'}</p>
            <Link to="/mi-cuenta" style={{display:'inline-block',background:'#111614',color:'#fff',fontWeight:700,padding:'.85rem 2rem',borderRadius:'100px',textDecoration:'none'}}>
              Ir a mi cuenta
            </Link>
          </>
        )}

      </div>
    </div>
  );
}